import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import Vue from 'vue';
import VueNativeNotification from 'vue-native-notification';

Vue.use(VueNativeNotification, {
  // automatic permission request before showing notification (default: true)
  requestOnNotify: true,
});

window.Pusher = Pusher;

// Laravel Reverb configuration
const config = {
  broadcaster: 'pusher',
  key: process.env.VUE_APP_REVERB_APP_KEY,
  cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
  wsHost: process.env.VUE_APP_REVERB_HOST,
  wsPort: process.env.VUE_APP_REVERB_PORT,
  wssPort: process.env.VUE_APP_REVERB_PORT,
  forceTLS: process.env.VUE_APP_REVERB_SCHEME === 'https',
  encrypted: process.env.VUE_APP_REVERB_SCHEME === 'https',
  enabledTransports: ['ws', 'wss'],
  authEndpoint: process.env.VUE_APP_LARAVEL_API_URL + '/broadcasting/auth',
  auth: {
    headers: {
      Authorization: 'Bearer ' + (localStorage.getItem('token') || ''),
    },
  },
  namespace: 'App.Events',
};

// initialize Echo if Reverb configuration is available
if (process.env.VUE_APP_REVERB_APP_KEY) {
  try {
    window.Echo = new Echo(config);

    // make Echo available as a Vue prototype for component access
    Vue.prototype.$echo = window.Echo;
  } catch (error) {
    console.error('Failed to initialize Laravel Echo:', error);
  }
}
